<template>
    <zangyou-list />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import ZangyouListForm from '@/components/shinsei/list/ZangyouListForm.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'zangyou-list': ZangyouListForm
    }
})
</script>
